import NoIMG from "@/App/Assets/Images/empty.png";
import Badge from "@/Components/Badge/Badge";
import Center from "@/Components/Base/Center";
import Spinner from "@/Components/Spinner/Spinner";
import Tooltip from "@/Components/Tooltip/Tooltip";
import { useSetBranch } from "@/shared/atoms/useBranch";
import { useSetEnabledWindowReload } from "@/shared/atoms/useEnabledWindowReload";
import useBranchImageHook from "@/shared/hooks/useBranchImageHook";
import { cn } from "@/shared/utils/cn";
import { asArray } from "@/shared/utils/helpers";
import { BranchGroup } from "@/shared/utils/interfaces";
import useOrdersQuery from "@/shared/v2/queries/useOrdersQuery";

const Formule = ({
  branch,
  isActive,
}: {
  branch: BranchGroup;
  isActive: boolean;
}) => {
  const { url, isPending } = useBranchImageHook(branch.branch.id);
  const setBranch = useSetBranch();
  const setEnabledWindowReload = useSetEnabledWindowReload();
  const query = useOrdersQuery(undefined, 1, branch.branch);

  return (
    <div className="relative">
      <Tooltip content={branch.branch.name}>
        <div>
          <div
            onClick={() => {
              setEnabledWindowReload(false);
              setBranch(branch.branch);
            }}
            className={cn(
              "mr-4 flex size-24 md:size-28 cursor-pointer items-center justify-center whitespace-nowrap rounded-full border-[0.5rem] bg-white p-2 text-center",
              isActive ? "border-primary" : "border-white"
            )}
          >
            {isPending ? (
              <Center alignItems={"center"}>
                <Spinner
                  color={isActive ? "var(--white)" : "var(--primary)"}
                  size="0.3rem"
                />
              </Center>
            ) : (
              <img
                src={url.includes("undefined") ? NoIMG : url}
                className="h-16 w-16 object-contain"
              />
            )}
          </div>
        </div>
      </Tooltip>
      <div className="absolute -top-2 right-4 z-2">
        <Badge>
          {query.isPending ? (
            <div>
              <Spinner color="white" size="0.1rem" />
            </div>
          ) : (
            <div>{asArray(query?.data?.[0])?.length}</div>
          )}
        </Badge>
      </div>
    </div>
  );
};

export default Formule;
